// extracted by mini-css-extract-plugin
module.exports = {"our-projects":"our-projects_our-projects__2hRzD","title":"our-projects_title__2OQz9"};